/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import StudentRouteLinkItem from './StudentRouteLinkItem';
import ContactInformationIcon from 'icons/ContactInformationIcon';

const messages = defineMessages({
  title: {id: 'navigation.contact-info'},
});

const ContactInfoItem = () => (
  <StudentRouteLinkItem
    iconBefore={ContactInformationIcon}
    route="midas/student/contact-information"
    title={messages.title}
  />
);

export default ContactInfoItem;
